import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const AnalyticsIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M7 17L7 13M12 17L12 7M17 17V11" />
      <path d="M21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5Z" />
    </SvgIcon>
  )
}
